





























import type { PropType } from '@nuxtjs/composition-api';
import {
  computed, defineComponent,
  toRef,
} from '@nuxtjs/composition-api';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import type { TransformedCustomerAddress } from '~/modules/customer/composables/types';
import userAddressesGetters from '~/modules/customer/getters/userAddressesGetters';
import { useCheckoutStore } from '~/stores/checkout';

export default defineComponent({
  name: 'BillingAddressDetails',
  components: {
    JetUiButton,
  },
  props: {
    address: {
      type: Object as PropType<TransformedCustomerAddress>,
      required: true,
    },
    originMethods: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const address = toRef(props, 'address');
    const { getCurrentAddressId } = useCheckoutStore();
    const isActive = computed(() => getCurrentAddressId(props.originMethods ?? 'shipping') === userAddressesGetters.getId(address.value));

    const userAddress = computed(() => ({
      id: userAddressesGetters.getId(address.value),
      firstName: userAddressesGetters.getFirstName(address.value),
      lastName: userAddressesGetters.getLastName(address.value),
      street: userAddressesGetters.getStreetName(address.value),
      streetNumber: userAddressesGetters.getApartmentNumber(address.value),
      postalCode: userAddressesGetters.getPostCode(address.value),
      city: userAddressesGetters.getCity(address.value),
      province: userAddressesGetters.getProvince(address.value) || '',
      country: userAddressesGetters.getCountry(address.value),
      phone: userAddressesGetters.getPhone(address.value),
      isDefault: userAddressesGetters.isDefault(address.value),
      isDefaultShipping: userAddressesGetters.isDefaultShipping(address.value),
      isDefaultBilling: userAddressesGetters.isDefaultBilling(address.value),
    }));

    return {
      userAddress,
      isActive,
    };
  },
});
